import selectFolderAndRow from '../orchestrators/selectFolderAndRow';
import selectRow from '../orchestrators/selectRow';
export interface MailRowRouteParameters {
    folderId?: string;
    rowId: string;
}
export default function mailRowRouteHandler(parameters: MailRowRouteParameters) {
    selectRow(parameters.rowId);
}
export function mailRowFolderRouteHandler(parameters: MailRowRouteParameters) {
    const { folderId, rowId } = parameters;
    selectFolderAndRow(folderId, rowId);
}
export function mailRowCleanupRouteHandler(
    oldRoute?: string[],
    oldParameters?: any,
    newRoute?: string[],
    newParameters?: any
) {
    const toSearch = !!newRoute && newRoute.some(value => value == 'search');
    return toSearch;
}
